import { StaticDataSource } from '../Data';
var EnumDecorator = /** @class */ (function () {
    function EnumDecorator(enumType) {
        this.enumType = enumType;
        // @ts-ignore
        enumType[EnumDecorator.enumDescriptorSymbol] = {};
    }
    /**
     * Describe the enum item.
     * @param enumItem Item you are describing.
     * @param display Display name to use, e.g. for use in drop downs.
     * @param description Additional description about the item.
     * @param order Override sort order.
     */
    EnumDecorator.prototype.describe = function (enumItem, display, description, order) {
        // @ts-ignore
        this.enumType[EnumDecorator.enumDescriptorSymbol][enumItem] = { display: display, description: description, order: order };
    };
    EnumDecorator.enumDescriptorSymbol = Symbol("Neo.EnumDescriptor");
    return EnumDecorator;
}());
var EnumHelper = /** @class */ (function () {
    function EnumHelper() {
    }
    /**
     * Decorate an enum and it's items.
     * @param enumType The enum.
     * @param callback Callback decorator. E.g: e.describe(Enum.Item1, "Display Value")
     */
    EnumHelper.decorateEnum = function (enumType, callback) {
        var helper = new EnumDecorator(enumType);
        callback(helper);
    };
    /**
     * Creates a static datasource from an Enum.
     */
    EnumHelper.asDatasource = function (enumType) {
        return StaticDataSource.fromEnum(enumType);
    };
    /**
     * Creates a list of IEnumItem from an enum, using the enum decorator data.
     */
    EnumHelper.asList = function (enumObject) {
        var descriptorMap = enumObject[EnumDecorator.enumDescriptorSymbol] || {};
        var keys = Object.keys(enumObject).filter(function (key) { return typeof enumObject[key] === "number"; });
        var items = [];
        if (keys.length === 0) {
            // String enum type.
            keys = Object.keys(enumObject);
        }
        var index = keys.length;
        for (var _i = 0, keys_1 = keys; _i < keys_1.length; _i++) {
            var key = keys_1[_i];
            var id = enumObject[key];
            var name_1 = void 0, description = void 0;
            var itemDescriptor = descriptorMap[id];
            if (itemDescriptor) {
                name_1 = itemDescriptor.display;
                description = itemDescriptor.description;
            }
            else {
                name_1 = key.readable();
            }
            items.push({ id: id, name: name_1, description: description, order: itemDescriptor && itemDescriptor.order !== undefined ? itemDescriptor.order : index });
            index += 1;
        }
        return items.sortBy(function (c) { return c.order; }).map(function (item) { return ({ id: item.id, name: item.name, description: item.description }); });
    };
    /**
     * Gets the metadata for an enum item.
     * @param enumType Enum object. E.g. Status
     * @param enumItem Enum item. E.g. Status.Pending
     */
    EnumHelper.getItemMetadata = function (enumType, enumItem) {
        // @ts-ignore
        var descriptorMap = enumType[EnumDecorator.enumDescriptorSymbol] || {};
        var itemDescriptor = descriptorMap[enumItem];
        // @ts-ignore
        var name = enumType[enumItem];
        if (!itemDescriptor) {
            itemDescriptor = name ? { name: name, display: name.readable() } : { name: enumItem.toString(), display: enumItem.toString() };
        }
        else {
            itemDescriptor.name = name;
        }
        return itemDescriptor;
    };
    /**
     * Returns `true` if this item looks like an enum item.
     *
     * E.g. has an `id` and `name` property.
     */
    EnumHelper.isEnumItem = function (item) {
        if (typeof item === "object") {
            var properties = Object.getOwnPropertyNames(item);
            if (properties.length <= 3 && properties.some(function (c) { return c === "id"; }) && properties.some(function (c) { return c === "name"; })) {
                return true;
            }
        }
        return false;
    };
    return EnumHelper;
}());
export { EnumHelper };
